export const formatNumberDot = num => num.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1.")
export const formatNumberSpace = num => num.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ")
